import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const logoutToChangeAccount = async () => axios.post(Routes.LOGOUT);

export const useLogoutToChangeAccount = () => {
  return useMutation({
    mutationKey: [Keys.LOGOUT_MUT],
    mutationFn: logoutToChangeAccount,
  });
};
